module.exports = __webpack_public_path__ + "img/fondo-banner-principal.98d7bea6.svg";